import styles from './rm.module.css';

const RecruiterMessages = ({ onProfileClick }) => {
    const profiles = [
        { id: 1, name: 'BahuBali Devasena' },
        { id: 2, name: 'Profile 2' },
        { id: 3, name: 'Profile 3' },
        { id: 4, name: 'Profile 4' },
        // Add more profiles as needed
    ];

    return (
        <div className={styles.container}>
            <div className={styles.rm}>
            <h3>Recruiter Messages</h3>
            <ul >
                {profiles.map(profile => (
                    <li key={profile.id} onClick={() => onProfileClick(profile)}>
                        {profile.name}
                    </li>
                ))}
            </ul>
            </div>
        </div>
    );
};

export default RecruiterMessages;